// Material UI
import { Button } from '@mui/material';

// Icons
import { CalendarTodayOutlined } from '@mui/icons-material';

// Utils
import { buildGoogleCalendarLink } from '../../../../../../../utils/googleCalendarUtils';

const AddToMyCalendarButton = ({ event }) => {
  const handleClick = () => {
    const link = buildGoogleCalendarLink({
      title: event.title,
      start: event.start,
      end: event.end,
      description: event.description,
      location: event.location,
      rrule: event.rrule,
    });
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button
      disableElevation
      disableRipple
      variant="contained"
      startIcon={<CalendarTodayOutlined style={{ width: '27px', height: '27px' }} />}
      style={{
        textTransform: 'none',
        color: 'white',
        backgroundColor: '#F17023',
        borderRadius: '24px',
        height: '52px',
        width: '280px',
        padding: '12px 16px',
        fontWeight: 700,
        fontSize: '16px',
      }}
      onClick={handleClick}
    >
      Add to my Google Calendar
    </Button>
  );
};

export default AddToMyCalendarButton;
